import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { ChatTileComponent } from './components/chat-tile/chat-tile.component';
import { MessageBubbleComponent } from './components/message-bubble/message-bubble.component';
import { ChatroomComponent } from './components/chatroom/chatroom.component';
import { LayoutComponent } from './components/layout/layout.component';
import { RouterModule } from '@angular/router';
import { SignedTokenInterceptor } from './interceptors/signed-token.interceptor';
import { FormsModule } from '@angular/forms';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { DateTimeFormatPipe } from './pipes/date-time-format.pipe';
import { InfiniteScrollDirective } from './directives/infinite-scroll.directive';
import { RefreshSurfaceDirective } from './directives/refresh-surface.directive';
import { NavbarComponent } from './components/navbar/navbar.component';

import { LoaderComponent } from './components/loader/loader.component';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

import { CustomDropdownSedeComponent } from './components/custom-dropdown-sede/custom-dropdown-sede.component';

import { TooltipComponent } from './components/tooltip/tooltip.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { ImageModalComponent } from './components/message-bubble/components/image-modal/image-modal.component';
import { FlowReplyComponent } from './components/message-bubble/components/flow-reply/flow-reply.component';
import { IconFileComponent } from './components/icons/icon-file/icon-file.component';
import { CustomDropdownSedeItemComponent } from './components/custom-dropdown-sede/custom-dropdown-sede-item/custom-dropdown-sede-item.component';

@NgModule({
  declarations: [
    AppComponent,
    ChatTileComponent,
    MessageBubbleComponent,
    ChatroomComponent,
    LayoutComponent,
    DateTimeFormatPipe,
    InfiniteScrollDirective,
    RefreshSurfaceDirective,
    NavbarComponent,
    LoaderComponent,
    CustomDropdownSedeComponent,

    TooltipComponent,
    TooltipDirective,
    ImageModalComponent,
    FlowReplyComponent,
    IconFileComponent,
    CustomDropdownSedeItemComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    SweetAlert2Module.forRoot(),
    LottieModule.forRoot({ player: playerFactory }),
    RouterModule.forRoot([]),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SignedTokenInterceptor,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
